// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.mainDiagram{
    text-align: center;
    display: grid;
    row-gap: 25px;
}

.diagram-component{
    display: flex;
    justify-content: center;
}
.Circleiteam{
    display: flex;
    justify-content: center;
    width: auto;
}

.Circleiteam p{
    z-index: 3;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100px;
    border: 1px solid rgb(198, 196, 196);
    border-radius: 50px;
    box-shadow: 0px 0px 26.79px 0px rgba(0, 0, 0, 0.25);
    width: 300px;
    height: 50px;
    font-size: 16px;
    font-weight: 600;
    cursor: pointer;
    background-color: white;
}
.Circleiteam p:hover{
    border-bottom: 10px yellow;
}

.circle_dig {
    background-color: #0096FE;
    margin: auto;
    padding: 2% 8% 7% 6%;
    height: 440px;
    width: 380px;
    border-radius: 60%;
    position: relative;
    top: -750px;
    box-shadow: 0px 3.25px 36.61px 0px rgba(0, 0, 0, 0.25);
    display: flex;
}
 
.circle_dig::before {
    content: '';
    position: absolute;
    top: -70px; 
    left: -70px;
    right: -70px;
    bottom: -50px;
    border: 1px solid rgba(0, 150, 254); 
    border-radius: 50%;
    z-index: -1;
}

.circle_dig::after {
    content: '';
    position: absolute;
    top: -90px;
    left: -70px;
    right: -70px;
    bottom: -80px;
    border-top: 7px solid var(--border-color); 
    border-radius: 50%;
    transition: border-color 0.3s ease;
}

.circle_dig h1{
    width: 400px;
    font-size: 30px;
    font-weight: 700;
    line-height: 38.42px;
    text-align: center;
    color: white;
}

.circle_dig li{
    width: 312px;
    font-size: 15px;
    font-weight: 500;
    line-height: 18px;
    text-align: left;
    margin-left: 20px;
    
}

.circle_dig div{
    margin-top: 10%;
    color: white;
}
circle_dig ul{
    display: flex;
    justify-content: right;
}

.navigation-buttons {
    width: 100%;
    display: flex;
    position: absolute;
    left: 40%;
    top: 75%;
    column-gap: 20px;
}
.navigation-buttons p{
    font-size: 15px;
    font-weight: 700;
    text-align: center;
}

.navigation-buttons button {
    color: white;
    background-color:#0096FE;
    border: 1px solid white;
    padding: 10px 20px;
    border-radius: 50%;
    cursor: pointer;
    z-index: 5;
}

.navigation-buttons button:hover {
    background-color: #0096FE;
}


@media (max-width: 1900px){
    .circle_dig::before {
        bottom: -100px;
    }
}
@media screen and (min-width: 1280px) {
    .App-modern-Circle {
        display: block;
    }

    .Carousel {
        display: none;
    }
}

@media screen and (min-width: 300px) and (max-width: 1280px) {
    .App-modern-Circle {
        display: none;
    }

    .Carousel {
        display: block;
    }
}`, "",{"version":3,"sources":["webpack://./src/styles/CircleInfo/CircleIntelligentAutomation.css"],"names":[],"mappings":";AACA;IACI,kBAAkB;IAClB,aAAa;IACb,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,WAAW;AACf;;AAEA;IACI,UAAU;IACV,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,oCAAoC;IACpC,mBAAmB;IACnB,mDAAmD;IACnD,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,uBAAuB;AAC3B;AACA;IACI,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,oBAAoB;IACpB,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,sDAAsD;IACtD,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mCAAmC;IACnC,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,WAAW;IACX,YAAY;IACZ,aAAa;IACb,yCAAyC;IACzC,kBAAkB;IAClB,kCAAkC;AACtC;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;IAChB,iBAAiB;;AAErB;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;AACA;IACI,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,gBAAgB;AACpB;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,YAAY;IACZ,wBAAwB;IACxB,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,UAAU;AACd;;AAEA;IACI,yBAAyB;AAC7B;;;AAGA;IACI;QACI,cAAc;IAClB;AACJ;AACA;IACI;QACI,cAAc;IAClB;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,cAAc;IAClB;AACJ","sourcesContent":["\r\n.mainDiagram{\r\n    text-align: center;\r\n    display: grid;\r\n    row-gap: 25px;\r\n}\r\n\r\n.diagram-component{\r\n    display: flex;\r\n    justify-content: center;\r\n}\r\n.Circleiteam{\r\n    display: flex;\r\n    justify-content: center;\r\n    width: auto;\r\n}\r\n\r\n.Circleiteam p{\r\n    z-index: 3;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    width: 100px;\r\n    border: 1px solid rgb(198, 196, 196);\r\n    border-radius: 50px;\r\n    box-shadow: 0px 0px 26.79px 0px rgba(0, 0, 0, 0.25);\r\n    width: 300px;\r\n    height: 50px;\r\n    font-size: 16px;\r\n    font-weight: 600;\r\n    cursor: pointer;\r\n    background-color: white;\r\n}\r\n.Circleiteam p:hover{\r\n    border-bottom: 10px yellow;\r\n}\r\n\r\n.circle_dig {\r\n    background-color: #0096FE;\r\n    margin: auto;\r\n    padding: 2% 8% 7% 6%;\r\n    height: 440px;\r\n    width: 380px;\r\n    border-radius: 60%;\r\n    position: relative;\r\n    top: -750px;\r\n    box-shadow: 0px 3.25px 36.61px 0px rgba(0, 0, 0, 0.25);\r\n    display: flex;\r\n}\r\n \r\n.circle_dig::before {\r\n    content: '';\r\n    position: absolute;\r\n    top: -70px; \r\n    left: -70px;\r\n    right: -70px;\r\n    bottom: -50px;\r\n    border: 1px solid rgba(0, 150, 254); \r\n    border-radius: 50%;\r\n    z-index: -1;\r\n}\r\n\r\n.circle_dig::after {\r\n    content: '';\r\n    position: absolute;\r\n    top: -90px;\r\n    left: -70px;\r\n    right: -70px;\r\n    bottom: -80px;\r\n    border-top: 7px solid var(--border-color); \r\n    border-radius: 50%;\r\n    transition: border-color 0.3s ease;\r\n}\r\n\r\n.circle_dig h1{\r\n    width: 400px;\r\n    font-size: 30px;\r\n    font-weight: 700;\r\n    line-height: 38.42px;\r\n    text-align: center;\r\n    color: white;\r\n}\r\n\r\n.circle_dig li{\r\n    width: 312px;\r\n    font-size: 15px;\r\n    font-weight: 500;\r\n    line-height: 18px;\r\n    text-align: left;\r\n    margin-left: 20px;\r\n    \r\n}\r\n\r\n.circle_dig div{\r\n    margin-top: 10%;\r\n    color: white;\r\n}\r\ncircle_dig ul{\r\n    display: flex;\r\n    justify-content: right;\r\n}\r\n\r\n.navigation-buttons {\r\n    width: 100%;\r\n    display: flex;\r\n    position: absolute;\r\n    left: 40%;\r\n    top: 75%;\r\n    column-gap: 20px;\r\n}\r\n.navigation-buttons p{\r\n    font-size: 15px;\r\n    font-weight: 700;\r\n    text-align: center;\r\n}\r\n\r\n.navigation-buttons button {\r\n    color: white;\r\n    background-color:#0096FE;\r\n    border: 1px solid white;\r\n    padding: 10px 20px;\r\n    border-radius: 50%;\r\n    cursor: pointer;\r\n    z-index: 5;\r\n}\r\n\r\n.navigation-buttons button:hover {\r\n    background-color: #0096FE;\r\n}\r\n\r\n\r\n@media (max-width: 1900px){\r\n    .circle_dig::before {\r\n        bottom: -100px;\r\n    }\r\n}\r\n@media screen and (min-width: 1280px) {\r\n    .App-modern-Circle {\r\n        display: block;\r\n    }\r\n\r\n    .Carousel {\r\n        display: none;\r\n    }\r\n}\r\n\r\n@media screen and (min-width: 300px) and (max-width: 1280px) {\r\n    .App-modern-Circle {\r\n        display: none;\r\n    }\r\n\r\n    .Carousel {\r\n        display: block;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
